import { render, staticRenderFns } from "./SchoolyearPlanningAddEdit.vue?vue&type=template&id=785b0582&scoped=true"
import script from "./SchoolyearPlanningAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolyearPlanningAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SchoolyearPlanningAddEdit.vue?vue&type=style&index=0&id=785b0582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b0582",
  null
  
)

export default component.exports